/** Create a focus trap for active modals **/
(() => {
    document.addEventListener("focusin", (event) => {
        const activeModal = document.querySelector('.modal.show');

        // No active modal, nothing to do
        if (!activeModal) {
            return;
        }

        // Element is in modal, that's fine
        if (activeModal.contains(event.target)) {
            return;
        }

        // Reset focus to modal
        activeModal.focus();
    })
}) ()
